import LoadingSpinner from '../assets/LoadingSpinner';
import NestedTableCell from './NestedTableCell';
import React from 'react';

interface NestedTableBodyProps {
  searchLoading: boolean;
  loading: boolean;
  columnOrder: string[];
  hiddenColumns: string[];
  filteredAndSortedRows: any[];
  savingRows: Set<number>;
  selectedRows: string[];
  handleRowSelect: (rowId: string) => void;
  inputRefs: React.MutableRefObject<(HTMLInputElement | HTMLSelectElement | null)[][]>;
  localRows: any[];
  setLocalRows: Function;
  getItemById: any;
  itemMetaById: Record<string, any>;
  resetSortingOnEdit: Function;
  handleTableKeyDown: Function;
  calculatePriceValue: Function;
  handleQuantityClick?: (rowIndex: number) => void;
  isLocked?: boolean;
}

const NestedTableBody: React.FC<NestedTableBodyProps> = ({
  searchLoading,
  loading,
  columnOrder,
  hiddenColumns,
  filteredAndSortedRows,
  savingRows,
  selectedRows,
  handleRowSelect,
  inputRefs,
  localRows,
  setLocalRows,
  getItemById,
  itemMetaById,
  resetSortingOnEdit,
  handleTableKeyDown,
  calculatePriceValue,
  handleQuantityClick,
  isLocked = false
}) => (
  <tbody>
    {(searchLoading || loading) ? (
      <tr>
        <td
          colSpan={columnOrder.filter(field => !hiddenColumns.includes(field)).length + 2}
          className="border border-gray-300 py-24 text-center bg-white"
        >
          <LoadingSpinner />
        </td>
      </tr>
    ) : (
      filteredAndSortedRows.map((row, r) => (
        <tr key={row._id || r} className={`hover:bg-yellow-100 dark:hover:bg-yellow-900/30 group cursor-pointer h-6 ${savingRows.has(r) ? 'bg-blue-50' : ''}`}>
          <td className="border border-gray-300 px-0 py-0 text-center bg-white h-6">
            {row._id && (
              <input
                type="checkbox"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                checked={row._id ? selectedRows.includes(row._id) : false}
                onChange={() => row._id && handleRowSelect(row._id)}
                onClick={(e) => e.stopPropagation()}
              />
            )}
          </td>
          <td className="border border-gray-300 px-1 py-0 text-center bg-white h-6">
            {savingRows.has(r) ? (
              <div className="flex items-center justify-center">
                <svg className="animate-spin h-3 w-3 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
            ) : (
              <div className="text-xs text-gray-500 font-medium">{r + 1}</div>
            )}
          </td>
          {columnOrder.filter(field => !hiddenColumns.includes(field)).map((field) => (
            <NestedTableCell
              key={field}
              field={field}
              row={row}
              rowIndex={r}
              columnOrder={columnOrder}
              inputRefs={inputRefs}
              localRows={localRows}
              setLocalRows={setLocalRows}
              getItemById={getItemById}
              itemMetaById={itemMetaById}
              resetSortingOnEdit={resetSortingOnEdit}
              handleTableKeyDown={handleTableKeyDown}
              calculatePriceValue={calculatePriceValue}
              handleQuantityClick={handleQuantityClick}
              isLocked={isLocked}
            />
          ))}
        </tr>
      ))
    )}
    {/* Spacer row to prevent dropdown overlap */}
    <tr>
      <td colSpan={columnOrder.filter(field => !hiddenColumns.includes(field)).length + 2} className="border-0 h-32"></td>
    </tr>
  </tbody>
);

export default NestedTableBody;